import type { PIconProps } from "@porsche-design-system/components-react"
import type { FinancingNotification } from "./FinancingNotification"

export function mapIcon(severity: FinancingNotification["severity"]): PIconProps["name"] {
	switch (severity) {
		case "error":
			return "warning"
		case "warning":
			return "warning"
		default:
			return "information"
	}
}
